import { FMDParametersService, Partner } from '@geovelo-frontends/commons';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './query-keys';
import { resolveQueryData } from './resolve-query-data';

export default function usePartnerFMDConfigQuery(
  partner: Partner | null | undefined,
  { isHolding }: { isHolding?: boolean } = {},
) {
  const enabled = !!partner && !isHolding;

  const query = useQuery({
    queryKey: queryKeys.partnerFMDConfig.all(partner?.id),
    queryFn: async () => {
      const [fmdConfig] = await FMDParametersService.getConfigurations(partner as Partner);
      return fmdConfig || null;
    },
    enabled,
    staleTime: Infinity,
  });

  const data = resolveQueryData(
    query.data,
    !partner ? undefined : isHolding || query.isError ? null : undefined,
  );

  return { ...query, data };
}
